import * as pConst from "../consts/profiles-consts.js";
import * as wConst from "../consts/website-consts.js";

const profileDefaultState = {Cache: []};


export const profileReducer = (state=profileDefaultState,action) =>{
  const resetState = {Cache: []};
  switch(action.type) {
    case wConst.RESET_STATE: {
      state = resetState;
      break;
    }

    case pConst.ACTION_FETCH_PROFILE_FULLFILLED: {
        state.Cache.push(action.payload.Result);
      break;
    }
    default: {break;}
  }
  return state;
};


